import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../../contexts/DataContext';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import { getSafeText } from '../../utils/valueResolver';

function Header() {
  const { data } = useContext(DataContext);
  const { i18n } = useTranslation();
  const location = useLocation();

  // ★ search が空なら hash から ?以降を拾う（HashRouter対策）
  const search =
    location.search ||
    (location.hash.includes('?') ? location.hash.slice(location.hash.indexOf('?')) : '');

  const productName = getSafeText(data?.ProductInfo?.productName) || 'Default Product';
  const serialNumber = data?.serialNumber || '000000';

  return (
    <header className="header box-header">
      <div className="header-content">
        <div className="logo-section">
          <div className="logo">
            <Link to={{ pathname: '/', search }}>
              <img src={`${process.env.PUBLIC_URL}/images/logo_sukui.svg`} alt="sukui" />
            </Link>
            <LanguageSelector />
          </div>
          <div className="mobile-border"></div>
        </div>
        <div className="product-info">
          <h1 className="product-title">{productName}</h1>
          <div className="product-id">No. {serialNumber}</div>
        </div>
      </div>
      <div className="header-border"></div>
    </header>
  );
}

export default Header;
